export default __webpack_public_path__ + "static/media/element_25.731573c6.jpg";